'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024 from "./presto.-Freemium2-F-A-Add-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002469 from "./presto.-Presto-Router$$anon$69.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$68() {
  this.bmT = null;
  this.bmL = null;
  this.bmM = false;
  this.bmU = null;
  this.bmV = false;
  this.bmY = null;
  this.bmR = null;
  this.bmS = false;
  this.bmN = null;
  this.bmO = false;
  this.bmP = null;
  this.bmQ = false;
  this.bmW = false;
  this.bmX = false;
  this.bmT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bmY = "Freemium2FAAddPage";
}
export { $c_Lpresto_PrestoRouter$$anon$68 as $c_Lpresto_PrestoRouter$$anon$68 };
$p = $c_Lpresto_PrestoRouter$$anon$68.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$68;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$68() {
}
export { $h_Lpresto_PrestoRouter$$anon$68 as $h_Lpresto_PrestoRouter$$anon$68 };
$h_Lpresto_PrestoRouter$$anon$68.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.bmT;
});
$p.M = (function() {
  if ((!this.bmM)) {
    this.bmL = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bmM = true;
  }
  return this.bmL;
});
$p.O = (function() {
  if ((!this.bmV)) {
    this.bmU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bmV = true;
  }
  return this.bmU;
});
$p.D = (function() {
  return this.bmY;
});
$p.t = (function() {
  if ((!this.bmS)) {
    this.bmR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmS = true;
  }
  return this.bmR;
});
$p.N = (function() {
  if ((!this.bmO)) {
    this.bmN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bmO = true;
  }
  return this.bmN;
});
$p.Q = (function() {
  if ((!this.bmQ)) {
    this.bmP = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002469.$c_Lpresto_PrestoRouter$$anon$69();
    this.bmQ = true;
  }
  return this.bmP;
});
$p.v = (function() {
  if ((!this.bmX)) {
    this.bmW = false;
    this.bmX = true;
  }
  return this.bmW;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee487) => ((p) => \u03b4scrutinee487))($j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024.$m_Lpresto_Freemium2FAAddPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$68, "presto.PrestoRouter$$anon$68", ({
  OJ: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$68 as $d_Lpresto_PrestoRouter$$anon$68 };
//# sourceMappingURL=presto.-Presto-Router$$anon$68.js.map
